module.exports = __webpack_public_path__ + "static/media/logo-internal-retina.1de4c238.png";